/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareClaimRequestOneOf3
 */
export interface ShareClaimRequestOneOf3 {
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf3
     */
    type: ShareClaimRequestOneOf3TypeEnum;
    /**
     * Configured appraiser email.
     * @type {string}
     * @memberof ShareClaimRequestOneOf3
     */
    email: ShareClaimRequestOneOf3EmailEnum;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf3
     */
    level?: ShareClaimRequestOneOf3LevelEnum;
    /**
     * 
     * @type {Array<object>}
     * @memberof ShareClaimRequestOneOf3
     */
    blockedModules?: Array<object>;
    /**
     * Marks this share as an appraisal request.
     * @type {boolean}
     * @memberof ShareClaimRequestOneOf3
     */
    isAppraisalRequest: boolean;
}


/**
 * @export
 */
export const ShareClaimRequestOneOf3TypeEnum = {
    Email: 'email'
} as const;
export type ShareClaimRequestOneOf3TypeEnum = typeof ShareClaimRequestOneOf3TypeEnum[keyof typeof ShareClaimRequestOneOf3TypeEnum];

/**
 * @export
 */
export const ShareClaimRequestOneOf3EmailEnum = {
    AnthonyhyperionclaimsCom: 'anthony@hyperionclaims.com'
} as const;
export type ShareClaimRequestOneOf3EmailEnum = typeof ShareClaimRequestOneOf3EmailEnum[keyof typeof ShareClaimRequestOneOf3EmailEnum];

/**
 * @export
 */
export const ShareClaimRequestOneOf3LevelEnum = {
    Rw: 'rw'
} as const;
export type ShareClaimRequestOneOf3LevelEnum = typeof ShareClaimRequestOneOf3LevelEnum[keyof typeof ShareClaimRequestOneOf3LevelEnum];


/**
 * Check if a given object implements the ShareClaimRequestOneOf3 interface.
 */
export function instanceOfShareClaimRequestOneOf3(value: object): value is ShareClaimRequestOneOf3 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('isAppraisalRequest' in value) || value['isAppraisalRequest'] === undefined) return false;
    return true;
}

export function ShareClaimRequestOneOf3FromJSON(json: any): ShareClaimRequestOneOf3 {
    return ShareClaimRequestOneOf3FromJSONTyped(json, false);
}

export function ShareClaimRequestOneOf3FromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimRequestOneOf3 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'email': json['email'],
        'level': json['level'] == null ? undefined : json['level'],
        'blockedModules': json['blockedModules'] == null ? undefined : json['blockedModules'],
        'isAppraisalRequest': json['isAppraisalRequest'],
    };
}

export function ShareClaimRequestOneOf3ToJSON(json: any): ShareClaimRequestOneOf3 {
    return ShareClaimRequestOneOf3ToJSONTyped(json, false);
}

export function ShareClaimRequestOneOf3ToJSONTyped(value?: ShareClaimRequestOneOf3 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'email': value['email'],
        'level': value['level'],
        'blockedModules': value['blockedModules'],
        'isAppraisalRequest': value['isAppraisalRequest'],
    };
}

